import IconClose from '../../assets/icons/IconClose';
import {
  TextBold,
  TextMedium,
  TextRegular,
} from '../../styles/GlobalStyledComponents';
import {
  ModalContainer,
  CardPartialPaymentHeader,
  DetailDescriptionText,
  ModalHeader,
  DetailTextWrapper,
  DetailPaymentList,
  DetailPaymentRow,
} from './DetailPartialPaymentStyledComponents';
import { IconCloseWrapper } from '../PaymentClickModal/PaymentClickModalStyledComponents';
import { pricesHelper } from '../../utils/paymentsHelper';
import { PaymentPlanData } from '../../interfaces/PaymentPlan';
import { dateFormatStandard } from '../../utils/dateTimeHelper';

interface DetailPartialPaymentProps {
  close: () => void;
  isOpen: boolean;
  payment: PaymentPlanData;
}

export const DetailPartialPayment: React.FC<DetailPartialPaymentProps> = ({
  close,
  isOpen,
  payment,
}) => {

  return (
    <ModalContainer id="partial-payment-detail-modal">
      <ModalHeader id="partial-payment-detail-header">
        <TextBold
          fontSize={24}
          lineHeight={32}
          id="partial-payment-detail-title"
        >
          Pago parcial
        </TextBold>
        <IconCloseWrapper
          onClick={() => close()}
          id="partial-payment-detail-close-icon"
        >
          <IconClose />
        </IconCloseWrapper>
      </ModalHeader>
      <DetailTextWrapper id="partial-payment-detail-text-wrapper">
        <DetailDescriptionText id="partial-payment-detail-description">
          <TextRegular
            fontSize={18}
            lineHeight={24}
            fontWeight={400}
            id="partial-payment-detail-description-text"
          >
            Te presentamos el importe pendiente por aplicar:
          </TextRegular>
        </DetailDescriptionText>
      </DetailTextWrapper>
      <CardPartialPaymentHeader id="partial-payment-detail-header">
        <TextBold
          fontSize={16}
          lineHeight={22}
          id="partial-payment-detail-amount"
        >
          Cuota {payment.order} - Plan de pagos
        </TextBold>
        <DetailPaymentList id="partial-payment-detail-list">
          <DetailPaymentRow marginLeft="8px" id="partial-payment-detail-row">
            <TextRegular
              fontSize={14}
              lineHeight={16}
              color="gray6"
              id="partial-payment-detail-row-text"
            >
              Importe de cuota
            </TextRegular>
            <TextRegular
              fontSize={14}
              lineHeight={16}
              color="gray6"
              id="partial-payment-detail-row-amount"
            >
              {pricesHelper(payment.amount)} €
            </TextRegular>
          </DetailPaymentRow>
          <DetailPaymentRow marginLeft="8px" id="partial-payment-detail-row">
            <TextRegular
              fontSize={14}
              lineHeight={16}
              color="gray6"
              id="partial-payment-detail-row-text"
            >
              Importe cobrado
            </TextRegular>
            <TextRegular
              fontSize={14}
              lineHeight={16}
              color="gray6"
              id="partial-payment-detail-row-amount"
            >
              {pricesHelper(payment.collected)} €
            </TextRegular>
          </DetailPaymentRow>
          <DetailPaymentRow id="partial-payment-detail-row">
            <TextMedium
              fontSize={14}
              lineHeight={16}
              id="partial-payment-detail-row-text"
            >
              Importe pendiente
            </TextMedium>
            <TextBold
              fontSize={14}
              lineHeight={16}
              id="partial-payment-detail-row-amount"
            >
              {pricesHelper(payment.amount - payment.collected)} €
            </TextBold>
          </DetailPaymentRow>
          <DetailPaymentRow id="partial-payment-detail-row">
            <TextMedium
              fontSize={14}
              lineHeight={16}
              id="partial-payment-detail-row-text"
            >
              Fecha de cobro
            </TextMedium>
            <TextBold
              fontSize={14}
              lineHeight={16}
              id="partial-payment-detail-row-amount"
            >
              {dateFormatStandard(new Date(payment.start_date), true)}
            </TextBold>
          </DetailPaymentRow>
        </DetailPaymentList>
      </CardPartialPaymentHeader>
    </ModalContainer>
  );
};
